import { Card, Col, Form, Row } from "antd";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import PageHeading from "../../../../components/common/PageHeading";
import { glAccountDetails } from "../../../../data/accounting";

function GlAccount() {
    const [glAccount, setGlAccount] = useState({});

    const { id }  = useParams();

    useEffect(()=>{
        const glAccountById = glAccountDetails.find((item)=>{
            return item.id === Number(id);
        })  
        setGlAccount(glAccountById);
    },[])
    
  return (
    <div className="gl-account">
      <PageHeading heading="GL Account" />
      <Row>
        <Col span={24}>
          <Card title={glAccount.accountName}>
            <Form labelCol={{ span: 8 }}
            wrapperCol={{ span: 11 }}
            colon={false}>
            <Form.Item label="Number">
                    <span>{glAccount.number}</span>
                </Form.Item>
                <Form.Item label="Account Name">
                    <span>{glAccount.accountName}</span>
                </Form.Item>
                <Form.Item label="Account Type">
                    <span>{glAccount.accountType}</span>
                </Form.Item>
                <Form.Item label="Sub-Account of">
                    <span>{glAccount.subAccountOf}</span>
                </Form.Item>
                <Form.Item label="Fund Account">
                    <span>{glAccount.fundAccount}</span>
                </Form.Item>
                <Form.Item label="Offset Account">
                    <span>{glAccount.offSetAccount}</span>
                </Form.Item>
                <Form.Item label="Subject to Management Fees">
                    <span>{glAccount.managementFees}</span>
                </Form.Item>
                <Form.Item label="Exempt from 1099 Reporting">
                    <span>{glAccount.reporting}</span>
                </Form.Item>
                <Form.Item label="Include on Cash Flow Account">
                    <span>{glAccount.cashFlow}</span>
                </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default GlAccount;
